import React from 'react';
import { cn } from '../utils';

export interface AuthPageProps {
  className?: string;
  children?: React.ReactNode;
  languageSelector?: React.ReactNode;
}

/**
 * AuthPage - Layout wrapper for authentication pages
 *
 * Provides consistent centered layout with background styling for auth flows.
 * Uses min-height with overflow-auto to ensure scrolling when content exceeds viewport.
 *
 * @example
 * ```tsx
 * <AuthPage languageSelector={<LanguageSelector />}>
 *   <SignIn {...props} />
 * </AuthPage>
 * ```
 */
export const AuthPage: React.FC<AuthPageProps> = ({ children, className, languageSelector }) => (
  <div className='h-dvh overflow-x-hidden overflow-y-auto bg-background'>
    {languageSelector && <div className='absolute top-4 right-4 z-10'>{languageSelector}</div>}
    <div
      className={cn(
        'min-h-full flex items-center justify-center py-2xl px-md sm:px-lg lg:px-xl',
        className
      )}
    >
      {children}
    </div>
  </div>
);

AuthPage.displayName = 'AuthPage';
